import type { NavigationGuard } from 'vue-router';
import { useMaintenanceStatusStore } from '@/stores/maintenance-status-store';

/**
 * Router middleware for maintenance page guard
 * Redirects users to the maintenance page if the application is under maintenance
 */
export const maintenancePageGuard: NavigationGuard = async (to) => {
   const maintenanceStatusStore = useMaintenanceStatusStore();

   if (import.meta.env.VITE_DEV && to.path === '/under-maintenance') {
      return '/';
   }

   if (import.meta.env.VITE_DEV) {
      return true;
   }

   // Fetch maintenance status on the first app load (page refresh)
   if (!maintenanceStatusStore.isFetched) {
      await maintenanceStatusStore.checkMaintenanceStatus();
   }

   // Skip check if already navigating to the maintenance page (prevent redirect loop)
   if (to.path === '/under-maintenance' && !maintenanceStatusStore.isAppAccessible) {
      return true;
   }

   // redirect to home if not under maintenance
   if (to.path === '/under-maintenance' && maintenanceStatusStore.isAppAccessible) {
      return '/';
   }

   // Redirect to the maintenance page if under maintenance
   if (!maintenanceStatusStore.isAppAccessible) {
      return '/under-maintenance';
   }

   // Allow navigation
   return true;
};
